// MIT License - Copyright (c) 2026 Doug McNall
import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// REVIEW-FINDINGS H9: silence chatty console in production builds.
// We keep console.error so genuine errors are still visible in the
// browser DevTools, and so any error-reporting tool that wraps it
// continues to work. .log/.warn/.debug/.info are no-oped to prevent
// inadvertent leaks of payload, token, or PII data.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.debug = noop;
  console.info = noop;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
